/* eslint-disable no-undef */
import 'bootstrap';
import Swiper, { Pagination } from 'swiper';
Swiper.use([Pagination]);
import 'swiper/swiper-bundle.css';
import '../css/index.sass';

(function($) {
  'use strict';
  $('#nav-toggle').on('click', function() {
    $(this).attr('aria-expanded', !String($(this).attr('aria-expanded')));
    $(this).toggleClass('collapsed');
    $(this.dataset.bsTarget).toggleClass('active');
    $('body').toggleClass('modal-open');
  });

  // eslint-disable-next-line no-unused-vars
  var mySwiper = new Swiper('.swiper-container', {
    loop: true,
    autoHeight: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  if ($('.needs-validation').length > 0) {
    $('.needs-validation').each(function() {
      let form = this;
      const args = JSON.parse(form.dataset.args);
      // eslint-disable-next-line no-unused-vars
      const defaultText = args.submit.default;
      const sendingText = args.submit.sending;
      const tryAgainText = args.submit.tryagain;
      const updateText = args.submit.update;

      $(form)
        .find(':input')
        .on('change', function() {
          if (
            $(this)
              .closest('form')
              .find('button.submit')
              .prop('disabled')
          ) {
            $(this)
              .closest('form')
              .find('button.submit')
              .prop('disabled', false)
              .html(updateText);
          }
        });

      form.addEventListener(
        'submit',
        function(event) {
          const submitBtn = $(this).find('button.submit');
          if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
          } else {
            event.preventDefault();
            event.stopPropagation();
            submitBtn
              .prop('disabled', true)
              .html(
                sendingText +
                  '<span class="spinner-border ms-2" role="status" aria-hidden="true"></span>'
              );

            grecaptcha.ready(function() {
              grecaptcha
                .execute('6LeAxUUaAAAAABiZtx-sMvxm4NZ8pXxVpeWiD4Rw', {
                  action: 'submit',
                })
                .then(function(token) {
                  // Add your logic to submit to your backend server here.
                  let data = new FormData(form);
                  console.log('data', data);
                  data.append('token', token);
                  console.log('data2', data);
                  $.ajax({
                    type: 'POST',
                    url: form.getAttribute('action'),
                    data: data,
                    cache: false,
                    contentType: false,
                    processData: false,
                  })
                    .done(function(data) {
                      let message = data.message;
                      if (data.data.status == 500 || data.data.status == 400) {
                        if (data.code && data.code == 'rest_invalid_param') {
                          message = Object.values(data.data.params)[0];
                        }
                        submitBtn.prop('disabled', false).html(message);
                      } else if (message) {
                        submitBtn.html(message);
                      } else {
                        submitBtn.prop('disabled', false).html(tryAgainText);
                      }
                      console.log('fail', data);
                      console.log('message', message);
                    })
                    .fail(function(e) {
                      let message = e.responseJSON.message;
                      console.log('fail', e);
                      console.log('message', message);

                      if (
                        e.responseJSON.code &&
                        e.responseJSON.code == 'rest_invalid_param'
                      ) {
                        message = Object.values(e.responseJSON.data.params)[0];
                      }

                      if (message) {
                        submitBtn.prop('disabled', false).html(message);
                      } else {
                        submitBtn.prop('disabled', false).html(tryAgainText);
                      }
                    });
                });
            });
          }
          form.classList.add('was-validated');
        },
        false
      );
    });
  }
})(jQuery);
